import { Dispatch, useEffect } from 'react';
import { AnyAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { setSquareGridCoordinates } from '../../../../../../app/redux/slices/squareGridCoordinatesSlice';
import { calculateArea, calculatePerimeter, generateSquareGridInPolygon } from '../../../../../../core/utils/map.utils';
import { sendDataToParent } from '../../../../base/functions/sendDataToParent';
import { Coordinates } from '../../../../../../core/types/types';

export const generateGridCells = (
    dispatch: Dispatch<AnyAction>,
    gridRegionPolygonCoordinates: Coordinates[],
    distanceBetweenGeneratedPoints: number,
) => {
    const generatedCells = generateSquareGridInPolygon(gridRegionPolygonCoordinates, distanceBetweenGeneratedPoints);

    if (generatedCells.success) {
        const area = calculateArea(gridRegionPolygonCoordinates);
        const perimeter = calculatePerimeter(gridRegionPolygonCoordinates);

        generatedCells.generatedGridCoordinatesLatLng &&
            dispatch(setSquareGridCoordinates(generatedCells.generatedGridCoordinatesLatLng));
        console.log('generated cells: ', generatedCells);
        sendDataToParent({
            type: 'grid-generated',
            generatedPoints: generatedCells.generatedGridCoordinatesLatLng,
            areaOfSingleCell: generatedCells.singleCellArea,
            perimeterOfDrawnRegion: perimeter,
            areaOfDrawnRegion: area,
        });
    } else if (gridRegionPolygonCoordinates) {
        toast.error(
            'تعداد نقاط ایجاد شده فراتر از مقدار ممکن برای تولید شبکه است. لطفا فاصله بین نقاط را بیشتر کنید یا منطقه کوچکتری را انتخاب کنید',
        );
    }
};
